import { Grid2 as Grid, TextField } from '@mui/material';
import React, { useContext } from 'react';
import IsMountedWrapper from '../../../utils/functions/isMountedWrapper';
import { ProductCategories } from '../../../utils/models/products';
import { ProductsStore } from '../../../utils/stores/ProductsStore';

// Inline replacements for the old makeStyles classes (kept as plain `sx`).
const availabilitySx = {
    sectionItem: {
        display: { xs: 'flex', sm: 'block' },
        flexDirection: { xs: 'column' },
        alignItems: { xs: 'center' },
        width: { sm: '90%', md: 'auto' },
    },
    selectFields: {
        width: { xs: '100%', sm: '90%' },
        '& .MuiOutlinedInput-root': { height: 54 },
    },
    menu: { width: 190 },
} as const;

/**
 * Home-page only: lets the visitor pick which tour to check availability for.
 * On the product page the tour is fixed by the URL, so this control is not used there.
 */
export default function TourSelect() {
    const productController = useContext(ProductsStore);
    const isMounted = IsMountedWrapper();

    const tours = productController.products.filter(
        (prod) => prod.category === ProductCategories.CAIRNS && prod.productCode
    );

    const handleTourChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selected = productController.products.find((prod) => prod.productCode === event.target.value);
        if (!selected) return;
        productController.setProduct(selected, isMounted);
        // Drop any sessions/time left over from a previously selected tour so the
        // availability for the new product is fetched fresh (see HomeBookingCTA effect).
        productController.setAvailability((prev) => ({ departureDate: prev.departureDate }), isMounted);
    };

    return (
        <Grid size={{ xs: 12 }} sx={availabilitySx.sectionItem}>
            <TextField
                select
                sx={availabilitySx.selectFields}
                value={productController.product?.productCode || ''}
                onChange={handleTourChange}
                SelectProps={{ native: true, MenuProps: { sx: availabilitySx.menu } }}
                variant="outlined"
            >
                <option value="" disabled>
                    Select a tour
                </option>
                {tours.map((tour) => (
                    <option value={tour.productCode} key={tour.productCode}>
                        {tour.name}
                    </option>
                ))}
            </TextField>
        </Grid>
    );
}
